import styled from 'styled-components'

export const Wrapper = styled.div`
  border: 1px solid #ccc;
  border-radius: 4px;
`

export const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
`

export const Label = styled.label`
  margin: 0;
  font-weight: bold;
`

export const Button = styled.button`
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  font-size: 14px;
  background-color: ${p => p.theme.colors.success};
  color: #fff;

  &:focus {
    outline: none;
  }
`

export const Icon = styled.em`
  font-size: 20px;
`

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
`

export const THead = styled.thead``

export const TBody = styled.tbody``

export const TR = styled.tr`
  ${THead} & {
    border-bottom: ${p => p.noCols ? 'none' : '1px solid #ccc'};
  }

  ${TBody} &:not(:last-child) {
    border-bottom: 1px solid #ccc;
  }
`

export const TH = styled.th`
  padding: 10px 15px;
  font-size: 0.8rem;
  color: ${p => p.disabled ? '#888' : p.theme.colors.primary};

  &:not(:first-child) {
    border-left: 1px solid #ccc;
  }

  &:not(:last-child) {
    border-right: 1px solid #ccc;
  }
`

export const TD = styled.td`
  position: relative;
  padding: 0;

  &:not(:first-child) {
    border-left: 1px solid #ccc;
  }

  &:not(:last-child) {
    border-right: 1px solid #ccc;
  }
`

export const Input = styled.input`
  padding: 10px 15px;
  width: 100%;
  border: none;
  box-shadow: ${p => p.error ? '0 0 0 1px red' : 'none'};
  color: #444;
  outline: none;
  transition: all 150ms ease;

  ${TR}:last-child > ${TD}:first-child > & {
    border-bottom-left-radius: 4px;
  }

  ${TR}:last-child > ${TD}:last-child > & {
    border-bottom-right-radius: 4px;
  }

  &:hover {
    box-shadow: ${p => p.disabled ? 'none' : `0 0 0 1px ${p.theme.colors.primary}`};
  }

  &:focus {
    box-shadow: ${p => `0 0 0 1px ${p.theme.colors.primary}`};
  }
`

export const DeleteIcon = styled.em`
  position: absolute;
  top: 50%;
  right: 15px;
  display: none;
  line-height: 0;
  font-size: 18px;
  color: #ccc;
  cursor: pointer;

  ${TR}:hover & {
    display: inline-block;
  }

  &:hover {
    color: ${p => p.theme.colors.danger};
  }
`